const WhoCanApply = (props) => {
  return (
    <section
      id={props.currentLang === "eng" ? "who-can-apply" : "kimler-basvurabilir"}
      className="w-full flex justify-center pt-32"
    >
      <div data-aos="fade-up" className="w-4/5 max-w-screen-xl space-y-6">
        <div className="flex justify-center">
          <h4 className="text-yellow-custom font-bold text-4xl sm:text-5xl md:text-7xl text-center">
            {props.currentLang === "eng"
              ? "WHO CAN APPLY?"
              : "KİMLER BAŞVURABİLİR?"}
          </h4>
        </div>

        <div className="text-center px-0 md:px-10 lg:px-16">
          <p className="text-white font-medium text-lg lg:text-2xl">
            {props.currentLang === "eng"
              ? "The event is open to all university students and new graduates who want to shape their careers with Unilever."
              : "Etkinlik, kariyerine Unilever ile yön vermek isteyen tüm üniversite öğrencilerine ve yeni mezunlara açıktır."}
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhoCanApply;
